import React from "react";
import logo from "./../../../vid_img/logo.png";
import "./LpNavBar.css"

const LpLogo = () => {
  return (
    <div className="lpLogo-container">
      <img src={logo} alt="logo" />
    </div>
  );
};

export default LpLogo;
